import { CONCERN_CODES } from '../lib/constants';
import { useI18n } from '../i18n';

interface Props {
  value: string[];
  onChange: (value: string[]) => void;
  labelledBy: string;
  describedBy?: string;
  /** The codes this class is offered (get_active_session's concern_phrases) — server-curated per grade, not a fixed constant. */
  allowed: string[];
}

// The "Something else" follow-up (Release 4b): same tile/ARIA pattern as
// TopicTags, but the option list is server-curated per grade (allowed)
// rather than the fixed TOPIC_TAGS constant — CONCERN_CODES only supplies
// the display emoji for whichever codes the server offered.
export function ConcernTags({ value, onChange, labelledBy, describedBy, allowed }: Props) {
  const { t } = useI18n();
  function toggle(code: string) {
    onChange(value.includes(code) ? value.filter((v) => v !== code) : [...value, code]);
  }

  return (
    <div className="sx-topics sx-concern-tags" role="group" aria-labelledby={labelledBy} aria-describedby={describedBy}>
      {CONCERN_CODES.filter((c) => allowed.includes(c.value)).map((c) => {
        const on = value.includes(c.value);
        return (
          <button
            key={c.value}
            type="button"
            aria-pressed={on}
            className={`sx-tile${on ? ' active' : ''}`}
            onClick={() => toggle(c.value)}
          >
            <span className="emoji" aria-hidden="true">{c.emoji}</span>
            <span>{t[`concern.${c.value}` as 'concern.unspecified']}</span>
            {on && <span className="tick" aria-hidden="true">✓</span>}
          </button>
        );
      })}
    </div>
  );
}
